module.exports = "/_next/static/resources/box-a1f5b7682ff8b05715bab0d807f7e5bf.webp";